const naturalNumberRegex = /^[0-9]+$/;

//exported solely for testing purposes
export function safeNumberParse(str) {
    /*This function is only used in a comparison check, where the other value is always positive. If the string being converted does not correspond to a natural number, the function returns -1 and will cause the comparison to fail*/
    if (naturalNumberRegex.test(str)) {
        return parseInt(str);
    } else {
        return -1;
    }
}

export const isCurrentMajorVersionViable = (comparisonMajorVersion: number): boolean => {
    let edgeVersion: string | null = null;
    const userAgent = window.navigator.userAgent;
    /*Depending on the version of Edge, the userAgent string will contain either Edge, Edg, EdgiOS, EdgA or EdgE. The version number is always the first group of digits after the string. The regex below matches the string and the version number*/
    const edgeRegex = /(?:Edge|Edg|EdgiOS|EdgA|EdgE)\/(\d+)/i;
    const match = userAgent.match(edgeRegex);
    if (match) {
        /*Get the value after the matched string*/
        edgeVersion = match[1];
    }
    try {
        if (edgeVersion && safeNumberParse(edgeVersion) >= comparisonMajorVersion) {
            return true;
        }
        return false;
    } catch {
        return false;
    }
};
